import { IconInfo, styled } from '@payright/web-components';
import { Tooltip } from 'react-tooltip';
import { SectionHeader } from './section-header';

export type LoanPurposeFieldProps = {
  loanPurpose: string;
  storeName: string;
};

const TOOLTIP_ID = 'tooltip-loan-purpose';

const LoanPurposeFieldContainer = styled.div`
  color: ${(props) => props.theme.colours.blue.base};
  margin-left: auto;
  margin-right: auto;
  display: flex;
  width: fit-content;
  align-items: center;
  justify-content: center;
  border-radius: 0.125rem;
  background-color: ${(props) => props.theme.colours.grey.light};
  padding: 1rem;
  padding-left: 3rem;
  padding-right: 1rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  outline: none;
`;

const HeaderContainer = styled.div`
  padding-left: 1rem;
  padding-right: 2rem;
  @media (min-width: 768px) {
    padding-left: 3rem;
    padding-right: 4rem;
  }
`;

const TooltipContainer = styled.div`
  fill: ${(props) => props.theme.colours.blue.base};
`;

export const LoanPurposeField = ({ loanPurpose, storeName }: LoanPurposeFieldProps) => {
  return (
    <LoanPurposeFieldContainer>
      <HeaderContainer>
        <SectionHeader>{loanPurpose}</SectionHeader>
      </HeaderContainer>
      <TooltipContainer>
        <IconInfo id={TOOLTIP_ID} />
        <Tooltip
          content={`${storeName} has told us that you are wanting to purchase ${loanPurpose}`}
          className={`inline-block align-text-top`}
          anchorSelect={`#${TOOLTIP_ID}`}
        ></Tooltip>
      </TooltipContainer>
    </LoanPurposeFieldContainer>
  );
};
